export enum CurrencyPosition {
  Left = 'left',
  Right = 'right',
}

export enum WeekStartDays {
  Auto = -1,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}
